/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from "react";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
import { LoaderCircle, Pencil, X } from "lucide-react";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Button } from "@/components/ui/button";
import { SupplierMappingList } from "./SupplierMappingList";

/* eslint-disable @typescript-eslint/no-unused-vars */
export const DocumentSupplierMappingSelect = ({
  data,
  parentKey,
  endPoint,
  keyValue,
}: any) => {
  const [
    _state,
    _setState,
    _searchAddress,
    _updateAddress,
    searchSupplier,
    updateSupplierMapping,
  ] = useDocument();
  const [edit, setEdit] = useState(false);
  const isReadOnly = useDocumentReadOnly();
  const [isPending, startTransition] = useState(false);
  const updateSupplierMappingData = async (prop: any) => {
    startTransition(true);
    await updateSupplierMapping({ key: parentKey, payload: prop });
    startTransition(false);
  };

  return (
    <ConditionRenderer condition={edit}>
      <div className="flex justify-between items-center w-full">
        <SupplierMappingList
          placeholder={`Search ${keyValue?.replaceAll("_", " ")}`}
          isPending={isPending}
          onChange={(prop: string) => {
            setEdit(false);
            updateSupplierMappingData(prop);
            // updateSupplierMapping({ key: parentKey, payload: prop });
          }}
          onSearch={(prop) =>
            searchSupplier({
              value: prop,
              endPoint: endPoint.value.replace("api", ""),
            })
          }
          value={""}
          onBlur={() => {}}
        />
        <Button
          size={"icon"}
          className="text-red-500"
          variant={"ghost"}
          onClick={() => setEdit(false)}
        >
          <X />
        </Button>
      </div>
      <div
        className="flex justify-between items-center w-full cursor-pointer"
        onClick={() => !isReadOnly && setEdit(true)}
      >
        <span className="flex flex-col gap-1 py-2">
          {data?.supplier_name ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Supplier name: </span>
              {data.supplier_name}
            </span>
          ) : null}

          {data.address1 ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Address 1: </span>
              {data.address1}
            </span>
          ) : null}

          {data.address1 ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Address 2: </span>
              {data.address2}
            </span>
          ) : null}

          {data.country ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Country: </span>
              {data.country}
            </span>
          ) : null}

          {data.city ? (
            <span>
              <span className="text-[rgb(148,163,184)]">City: </span>
              {data.city}
            </span>
          ) : null}

          {data.pin_code ? (
            <span>
              <span className="text-[rgb(148,163,184)]">Pin Code: </span>
              {data.pin_code}
            </span>
          ) : null}

          {Array.isArray(data) ? (
            <span>
              {data
                ?.map((item: any) => item?.text || "")
                .filter((text: string) => text !== "")
                .join(", ")}
            </span>
          ) : null}

          {data?.text && typeof data === "object" && !Array.isArray(data) ? (
            <span>{data.text}</span>
          ) : null}
        </span>
        <Button
          size={"icon"}
          className="text-primary"
          variant={"ghost"}
          disabled={isReadOnly}
          onClick={(e) => {
            e.stopPropagation();
            setEdit(true);
          }}
        >
          <Pencil />
        </Button>
        {isPending ? (
          <span className="absolute left-0 top-0 w-full  h-full bg-white/40 flex items-center justify-center">
            <LoaderCircle className="animate-spin" />
          </span>
        ) : null}
      </div>
    </ConditionRenderer>
  );
};
